import { useState } from "react";
import {
  pin_project,
  unpin_project,
} from "../../App/actions/projectActions";
import { useDispatch, useSelector } from "react-redux";
import { MoreVert } from "@material-ui/icons";
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";
import useLanguage from "../common_hooks/useLanguage";

function MENU_SEARCH_PROJECT({
  project,
  toggleSearch,
  toggle_modal_push_member,
}) {
  const { project_props } = useSelector((state) => {
    return {
      project_props: state.project,
    };
  });

  const { language, dict } = useLanguage();

  const dispatch = useDispatch();

  const [modal_menu, set_modal_menu] = useState(false);
  const [anchor, set_anchor] = useState(null);

  const geo_project_id = project?._id;
  const { geo_project_pinned_list } = project_props;
  const is_inside_pinned = geo_project_pinned_list?.some(
    (pinned_project) => pinned_project?._id === geo_project_id
  );

  const handle_pin = async () => {
    toggleSearch();

    const body = { geo_project_id };

    if (is_inside_pinned) {
      dispatch(unpin_project(body, project));
    } else {
      dispatch(pin_project(body, project));
    }
  };

  const toggle_menu = (event) => {
    set_modal_menu(!modal_menu);
    if (event) set_anchor(event.currentTarget);
  };

  const Float_content = (
    <FLOAT_MENU
      id="basic-menu"
      anchorEl={anchor}
      open={modal_menu}
      onClose={toggle_menu}
    >
      <div style={{ width: "110px", display: "flex", flexDirection: "column" }}>
        <button
          className="button_big button_white flex justify_start"
          onClick={handle_pin}
        >
          {dict?.[is_inside_pinned ? "Unpin" : "Pin"]?.[language]}
        </button>
        <button
          className="button_big button_white flex justify_start"
          onClick={() => {
            toggleSearch();
            toggle_modal_push_member(project?.link);
          }}
          data-mapid="clickColabolator"
        >
          {dict?.["Collaboration"]?.[language]}
        </button>
      </div>
    </FLOAT_MENU>
  );

  return (
    <div>
      <button className="hover_bigger" onClick={(e) => toggle_menu(e)}>
        <MoreVert />
      </button>
      {Float_content}
    </div>
  );
}

export default MENU_SEARCH_PROJECT;
